"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var AiFillQuestionCircle_1 = require("@react-icons/all-files/ai/AiFillQuestionCircle");
function TokenLogo(_a) {
    var logo = _a.logo, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.alt, alt = _d === void 0 ? "Token logo" : _d;
    var _e = (0, react_1.useState)(false), error = _e[0], setError = _e[1];
    (0, react_1.useEffect)(function () {
        setError(false);
    }, [logo]);
    return logo && !error ? ((0, jsx_runtime_1.jsx)(StyledImg, { alt: alt, style: style, onError: function () { return setError(true); }, className: "twap-token-logo ".concat(className), src: logo })) : ((0, jsx_runtime_1.jsx)(AiFillQuestionCircle_1.AiFillQuestionCircle, { style: { width: 20, height: 20 }, className: "twap-token-svg" }));
}
exports.default = TokenLogo;
var StyledImg = (0, styled_components_1.styled)("img")({
    borderRadius: "50%",
    overflow: "hidden",
});
